import { FC } from 'react';
import { FormControl } from 'react-bootstrap';
import FormGroup, { FormGroupProps } from 'components/FormGroup';
import { RegexTypeEnum, useCheckLatin } from 'hooks/useCheckRegex';

interface MiddleInitialProps extends FormGroupProps {
    disabled?: boolean;
}

const MiddleInitial: FC<MiddleInitialProps> = ({ disabled, ...restProps }) => {
    const { trigger: triggerCheckLatin, renderCheckingPrompt } = useCheckLatin(
        RegexTypeEnum.LATIN_NAME,
        'middle_initial'
    );

    return (
        <>
            <FormGroup
                label={__('Middle Initial (If Applicable)')}
                className="form-label-nowrap"
                name="middle_initial"
                checker={(value: string) => {
                    if (disabled) {
                        return true;
                    }

                    // 支持一位字母或者一个点，选填
                    if (!/^[a-zA-Z.]?$/g.test(value)) {
                        return __('The name you entered is not valid');
                    }

                    return value ? triggerCheckLatin(value) : true;
                }}
                {...restProps}>
                <FormControl placeholder={__('Middle Initial')} disabled={disabled} />
            </FormGroup>
            {renderCheckingPrompt()}
        </>
    );
};

export default MiddleInitial;
